
import SignInButton from '../button';
import { StyleColorSchemeType } from '@/ui-kit/styles/enums';
import { SSOProviders } from '../enums';

/**
 * @component GoogleSignInButton
 *
 * @public
 */

export default {
  name: 'GoogleSignInButton',
  components: {
    SignInButton,
  },
  data: () => ({
    StyleColorSchemeType,
    SSOProviders,
  }),
};
